define('lib/view/ModalRegion',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    return Marionette.Region.extend({

        el: '#sb_dialog',

        constructor: function () {
            //$('#sb_dialog, .modal-backdrop').remove();
            var $dialogContainer = $('#sb_dialog');
            if ($dialogContainer.length === 0) {
                $dialogContainer = $('<div id="sb_dialog" class="modal fade" tabindex="-1" role="dialog" aria-modal="true"/>').appendTo(document.body);
            }

            Marionette.Region.prototype.constructor.apply(this, arguments);
            this._ensureElement();

            var instance = this;
            this.$el.on('hidden.bs.modal', function () {
                instance.empty();
                instance.triggerMethod('hide');

                instance.$el.off('hidden.bs.modal');
            });

            this.$el.on('show.bs.modal', function () {
                instance.$el.off('show.bs.modal');
                if (instance.$el.data('bs.modal').options) {
                    instance.$el.data('bs.modal').options.backdrop = instance.getOption('closeOnBackdropClick') ? true : 'static'
                } else if (instance.$el.data('bs.modal')._config) {
                    instance.$el.data('bs.modal')._config.backdrop = instance.getOption('closeOnBackdropClick') ? true : 'static'
                }
            });
        },

        onShow: function () {
            this.$el.modal('show');

            // WCAG 4.1.2 — give the dialog an accessible name from its injected content
            this.$el.attr('aria-modal', 'true');
            var $title = this.$el.find('.modal-title').first();
            if (!$title.length) {
                $title = this.$el.find('h1, h2, h3, h4, .cap, .title-main, .title').first();
            }
            if ($title.length) {
                if (!$title.attr('id')) {
                    $title.attr('id', 'sb_dialog_label');
                }
                this.$el.attr('aria-labelledby', $title.attr('id'));
            }

            if( $('.modal-backdrop.fade.in').length == 0 ){
                var cover = '<div class="modal-backdrop fade in"></div>';
                $('body').append(cover);
            }
        },

        onClose: function () {
            this.$el.modal('hide');
            $('#sb_dialog, .modal-backdrop').remove();
            this._onCloseModal();
        },

        hide: function () {
            this.$el.modal('hide');
            $('#sb_dialog, .modal-backdrop').remove();
            this._onCloseModal();
        },

        _onCloseModal: function(){
            if(!$('.modal.in').length) {
                $('body').removeClass('modal-open');
            } else{
                $('body').addClass('modal-open').css('padding-right', 'unset');
            }
        }

    });

});
